import React from 'react';
import './AccessDenied.css';

const APP_URL = process.env.REACT_APP_APP_URL || 'https://app.pycrust.io';

export default function AccessDenied() {
  return (
    <div className="access-denied">
      <h1 className="access-denied-title">Access denied</h1>
      <p className="access-denied-body">
        You encountered a development server for Pycrust.io. This is not accessible to customers or
        users. If you are a customer or user, go to the app below.
      </p>
      <a href={APP_URL} className="access-denied-link">
        Go to app.pycrust.io
      </a>
    </div>
  );
}
